import Vue from "vue";
import Vuex from "vuex";
import store from "./modules/store";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    store,
  },
});
